import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { getShareableContent } from 'controllers/CoreServiceController'
import { store } from 'index'
import { isSignedIn } from 'redux/actions/accountActions'
import { getMediaAudio } from './imageUtils'
import liked from '../images/liked.jpg'
import studio from '../images/studio.jpg'
import fansAreWaiting from '../images/fans-are-waiting.jpg'
import noLikesYet from '../images/no-likes-yet.jpg'
import { getAudioSrc, getVideoSrc } from './playlistUtils'

export const MESSAGE_STATUS = {
    DRAFT: 0,
    PUBLISHED: 1,
    MEDIA_PENDING_DRAFT: 2,
    MEDIA_PENDING_PUBLISHED: 3,
    MEDIA_FAILED: 4
}

export const APPROVAL_STATUS = {
    NONE: 0,
    APPROVED: 1,
    PENDING: 2,
    DECLINED: 3,
}

export const APPROVAL_REASON = {
    NONE: 0,
    COPYRIGHT: 1,
    CONTENT: 2
}


export const COLLECTION_TYPE = {
    NONE: 0,
    LIKED: 1,
    STUDIO: 2
}

/* These are actually reserved path part names */
export const RESERVED_STUDIO_NAMES = [
    'home',
    'private',
    'public',
    'liked',
    'studio',
    'song',
    'collection'
]

export const DENIAL_REASONS = [
    'None',
    'Potential copyright violation',
    'Content violates our terms of use'
]

export const LIKED_COLLECTION = {
    _id: 0,
    name: 'Liked',
    description: 'Songs I have liked',
    collectionType: COLLECTION_TYPE.LIKED,
    image: liked,
    emptyMessage: "You haven't liked any songs or videos yet",
    emptyImage: noLikesYet
}

export const STUDIO_COLLECTION = {
    _id: 1,
    name: 'Studio',
    description: 'All songs in this studio',
    collectionType: COLLECTION_TYPE.STUDIO,
    image: studio,
    emptyMessage: "You haven't published a song or video. Your fans are waiting",
    emptyNotArtistMessage: 'There is no content here yet',
    emptyImage: fansAreWaiting
}

export const MEDIA_TYPES = {
    AUDIO: ['audio/mpeg', 'audio/wav'],
    IMAGE: ['image/jpeg', 'image/png'],
    VIDEO: ['video/mp4', 'video/quicktime']
}

export const UPLOAD_MEDIA_TYPES = {
    AUDIO: ['audio/mpeg', 'audio/wav'],
    IMAGE: ['image/jpeg', 'image/png'],
    NOT_IMAGE: ['audio/mpeg', 'audio/wav', 'video/mp4', 'video/quicktime']
}

/**
 * Given the list of Studios in the currentRoomOwner, and the
 * signed-in userId, determine if the current Studio is an artist
 * studio by looking for a 'private' studio owner by the
 * signed-in userId.
 * @param {*} currentRoomOwner 
 * @param {*} userId 
 * @returns 
 */
export const isArtistStudio = (currentRoomOwner, userId) => {
    let isArtist
    if (currentRoomOwner) {
        const { rooms, user } = currentRoomOwner
        if (user === userId) {
            const ix = rooms.findIndex(rm => rm.name === 'private')
            isArtist = ix !== -1
        }
    }
    console.log(`isArtistStudio ${isArtist}`)
    return isArtist
}

export const isMyStudio = (currentRoomOwner, userId) => {
    let mine
    if (currentRoomOwner) {
        const { user } = currentRoomOwner
        mine = (user === userId)
    }
    return mine
}

const getMediaStatus = () => {
    const { playList } = store.getState().messages
    if (playList.length) {
        const { playListIndex } = store.getState().harmonize
        if (playListIndex < playList.length) {
            const { status } = playList[playListIndex]
            return status
        }
    }
    return MESSAGE_STATUS.DRAFT
}
/**
 * 
 * @returns 
 */
export const isMediaFailed = () => {
    return getMediaStatus === MESSAGE_STATUS.MEDIA_FAILED
}

/**
 * Gets the status of the current playList entry
 * @content If supplied this instance is checked instead of the playList
 * @returns True if status is one of the MEDIA_PENDING... values
 */
export const isMediaPending = (content) => {
    let status = getMediaStatus()
    if (content) {
        status = content.status
    }
    return status === MESSAGE_STATUS.MEDIA_PENDING_DRAFT || status === MESSAGE_STATUS.MEDIA_PENDING_PUBLISHED
}

export const isNoContent = () => {
    const { endOfMessages, playList } = store.getState().messages
    console.log(`isNoContent ${endOfMessages} ${playList.length}`)
    return !playList.length && endOfMessages
}
export const isNoMedia = () => {
    const { playList } = store.getState().messages
    if (playList.length) {
        const { playListIndex } = store.getState().harmonize
        const song = playList[playListIndex]
        return !(getVideoSrc(song) || getAudioSrc(song))
    } else {
        return true
    }

}


/**
 * Preview is true when:
 * 1) The user is not signedIn and accessType is not PUBLIC (because PUBLIC means anyone can hear/view the media:
 *    like a promo)
 * 2) The user is signed in and is out of credits
 * @param {*} accessType 
 * @returns 
 */
export const isSongPreview = (accessType) => {
    let isPreview
    if (isSignedIn()) {
        const { currentCredits, currentPromotionalCredits, currentArtistCredits } = store.getState().credits
        isPreview = !(currentCredits || currentArtistCredits || currentPromotionalCredits)
    } else {
        isPreview = accessType !== ACCESS_TYPES.PUBLIC
    }
    return isPreview
}

export const isSupport = (message) => {
    const { category } = message
    return category && category === 'Support'
}

/**
 * If the song has audio and the source starts with 'audio/' this
 * is "new format" meaning audio stored on Core Service. Legacy is
 * in Backblaze accessed through the Social Service.
 * @param {*} song 
 * @returns 
 */
export const isNewFormat = (song) => {
    const { media } = song
    if (media) {
        const audio = getMediaAudio(media)
        if (audio) {
            const { source } = audio
            return source.startsWith('audio/')
        }
    }
    return false
}

export const parseMessageForUrl = async (message) => {
    const ix = message.indexOf('https://')
    if (ix !== -1) {
        const ix2 = message.indexOf(' ', ix)
        const ix3 = ix2 !== -1 ? ix2 : message.length
        const urlString = message.substring(ix, ix3)
        console.log(`urlString ${urlString}`)
        try {
            const shareable = await getShareableContent(urlString)
            console.log('shareable', shareable)
            //siteName came back en-US for giants.com
            const { title, image, description } = shareable
            if (title && description && image) {
                const urlMessage = message.slice(0, ix)
                    + `<br /><b>${title}</b>`
                    + `<br /><a href='${urlString}' target='_blank' ><img src='${image}' style='width:80%' /></a>`
                    + `<br />${description}`
                    + message.slice(ix3 + 1)
                return urlMessage
            }
        } catch (error) {
            console.log('parseMessageForUrl error IGNORED', error)
        }
    }
    return message
}


export const replaceNewLine = (contents) => {
    if (contents) {
        return contents.replace(/\n/g, '<br />')
    } else {
        return contents
    }
}